import { useTranslation } from '@aimsos/i18n';
import { Trash2 } from 'lucide-react';

import ConfirmActionModal from './ConfirmActionModal';

/**
 * Confirm before deleting a contact (somebody who never signed in): the invitation link stops
 * working and nothing they had is lost.
 *
 * @param {object} props
 * @param {boolean} props.isOpen
 * @param {string} props.name
 * @param {() => void} props.onClose
 * @param {() => Promise<boolean>} props.onConfirm
 */
function DeleteContactConfirmModal({ isOpen, name, onClose, onConfirm }) {
  const { t } = useTranslation('people-access');
  return (
    <ConfirmActionModal
      isOpen={isOpen}
      onClose={onClose}
      onConfirm={onConfirm}
      title={t('memberDetail.confirm.deleteContact.title', { name })}
      message={t('memberDetail.confirm.deleteContact.message')}
      confirmLabel={t('memberDetail.confirm.deleteContact.confirm')}
      confirmVariant="danger"
      icon={Trash2}
    />
  );
}

export default DeleteContactConfirmModal;
